import {Component, EventEmitter, Input, Output} from '@angular/core';
import {QuoteRow} from '../../interfaces/quote';

/** The quotes of one opportunity or organisation as a compact table (#1698). The overview page has its own list shell. */
@Component({
  selector: 'bst-quote-list',
  templateUrl: './quote-list.component.html',
  styleUrls: ['./quote-list.component.scss'],
  standalone: false
})
export class QuoteListComponent {
  @Input({required: true}) rows: QuoteRow[] = [];
  // Off on an organisation's page, where every row has the same one.
  @Input() showOrganisation = true;
  // Download and Delete per row; the page owning the list does both.
  @Input() actions = false;
  @Output() download = new EventEmitter<QuoteRow>();
  @Output() remove = new EventEmitter<QuoteRow>();
  // A number was clicked; the link navigates, a host in a dialog closes it.
  @Output() opened = new EventEmitter<QuoteRow>();
}
